import { render, staticRenderFns } from "./help-modal.vue?vue&type=template&id=120bb096&scoped=true"
import script from "./help-modal.vue?vue&type=script&lang=js"
export * from "./help-modal.vue?vue&type=script&lang=js"
import style0 from "./help-modal.vue?vue&type=style&index=0&id=120bb096&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120bb096",
  null
  
)

export default component.exports